import { useMemo } from "react";
import { useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";

function MelhousBoard({ model }) {
  const currentView = useSignal("list");
  const layout = useMemo(() => model.ctxView(), [model]);
  return (
    <div className="w-full">
      <Board layout={layout} currentView={currentView} />
    </div>
  );
}

export default MelhousBoard;
